<template>
    <div class="about">
        <div class="banner">
                <el-carousel height="330px" arrow="always" >
                    <el-carousel-item v-for="(item,index) in bannerList" :key="index">
                        <img v-if="languageType == 0" @click="toProductdetail(item.category,item.productName)" :src="item.picUrl"/>
                        <img v-else @click="toProductdetail(item.category,item.productName)" :src="item.enPicUrl"/>
                    </el-carousel-item>
                </el-carousel>
        </div>
        <div class="tab">
            <div class="menu">
                <ul>
                    <li v-for="(item,index) in seriesList" :key="index" :class="currentIndex == index?'active':''" @click="checkIndex(index,item.path)">
                        <p>{{item.title}}</p>
                        <span>{{ item.otherName}}</span>
                    </li>
                </ul>
            </div>
            <div class="local">
                <p v-if="languageType == 0">当前位置：首页 > 关于胜骅 > {{ currentIndex == 0?'企业介绍':currentIndex == 1?'新闻公告':'展会信息'}}</p>
                <p v-else>Location: Home > Products > {{ currentIndex == 0?'About Arccer':currentIndex == 1?'Company News':'Exhibition'}}</p>
            </div>
        </div>
        <div class="content">
            <div class="display">
                <router-view :languageType="languageType"></router-view>
            </div>
            
        </div>
    </div>
</template>

<script>
export default {
    props:['languageType'],
    data () {
        return {
            currentIndex:'',
            bannerList:[],
            seriesList:[
                {
                    title:'企业介绍',
                    otherName:'About Arccer',
                    path:'introduce',
                },
                {
                    title:'新闻公告',
                    otherName:'Company News',
                    path:'news',
                    children:'newsdetail'
                },
                {
                    title:'展会信息',
                    otherName:'Exhibition',
                    path:'exhibition',
                    children:'exhibitiondetail'
                },
            ]

        }
    },
    created () {
        this.getBannerList()
        this.$emit('changeIndex',1)
        const path = this.$route.name
        document.documentElement.scrollTop = 0
        this.seriesList.forEach( (item,index) => {
            if(path == item.path || path == item.children){
                this.currentIndex = index
            }
        })
    },
    watch:{
        'languageType':function(a,b) {
            if(a != b){
                this.getBannerList()
            }
        }

    },
    methods:{
        getBannerList () {
            this.$http({
                url: this.$http.adornUrl('/web/banner/list'),
                method: 'post',
                data: {
                    'page': '1',
                    'limit': '999',
                    'type':2,
                    'productId':'',
                    'client':''
                }
                }).then(({data}) => {
                if (data && data.code === 0) {
                    let arr = []
                    data.page.list.forEach( item => {
                        if(item.client == 1){
                            if(this.languageType == 0 && item.picUrl){
                                arr.push(item)
                            }else if(this.languageType == 1 && item.enPicUrl){
                                 arr.push(item)
                            }
                        }
                    })
                    this.bannerList = arr
                } else {
                    this.bannerList = []
                }
            })
        },
        checkIndex (index,path) {
            const url = this.$route.name
            if (url == path) return
                this.currentIndex = index
                this.$router.push({ name:path })
        },
        toProductdetail (id,name) {
            this.$router.push({ name: 'productdetail',query:{key:JSON.stringify(name),id:JSON.stringify(id)}}),
            this.$emit('changeIndex',5)
        }
    }
}
</script>

<style lang="less" scoped>
    .about {
        max-width: 1920px;
        .banner {
            height: 330px;
            img {
                height: 330px;
                cursor: pointer;
            }
        }
        .tab {
            width: 1220px;
            margin: 0 auto;
            overflow: hidden;
            height: 76px;
            position: relative;
            z-index: 999;
            .menu {
                float: left;
                margin-top: 19px;
                ul {
                    li {
                        float: left;
                        // width: 150px;
                        padding: 0 40px;
                        cursor: pointer;
                        border-left: 1px solid #b2b2b2;
                        position: relative;
                        &:hover {
                            p {
                                color: #e21711;
                            }
                            span {
                                color: #e21711;
                            }
                        }
                        p {
                            color: #606060;
                            font-size: 20px;
                        }
                        span {
                            color: #606060;
                            font-size: 14px;
                        }
                        &:last-child {
                            border-right: 1px solid #b2b2b2;
                        }

                    }
                    li.active {
                        p {
                            color: #e21711;
                        }
                        span {
                            color: #e21711;
                        }
                    }
                    li::after {
                        content: '';
                        display: block;
                        position: absolute;
                        width: 100%;
                        height: 3px;
                        left: 0;
                        bottom: -15px;
                        background-color: #e21711;
                        opacity: 0;
                        transition: transform 0.2s ease-out,opacity 0.2s ease-out;
                        transform-origin: 50% 0%;
                        transform: scale(0.01,1);
                    }
                    li.active::after {
                        opacity: 1;
                        transform: scale(1,1);
                    }
                }
            }
            .local {
                float: right;
                p {
                    color: #606060;
                    font-size: 16px;
                    margin: 31px 0;
                }
            }
        }
        .content {
            position: relative;
            overflow: hidden;
            background-color: #f4f4f4;
            min-height: 800px;
            .display {
                width: 1220px;
                background-color: #ffffff;
                margin: 0 auto;
                margin-top: 20px;
                position: relative;
                z-index: 999;
            }
        }
        .content::before {
            content: '';
            display: block;
            position: absolute;
            top: -180px;
            left: -440px;
            width: 980px;
            height: 678px;
            background: url(../../static/img/long.png)no-repeat center center;
            transform: scale(0.8)
        }
        .content::after {
            content: '';
            display: block;
            position: absolute;
            right: -275px;
            bottom: -160px;
            width: 980px;
            height: 678px;
            background: url(../../static/img/tu.png)no-repeat center center;
            transform: scale(0.8)
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/about.vue